/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionCard_org = {
    readonly " $fragmentRefs": FragmentRefs<"SuggestionAction_org" | "SuggestionBody_org" | "SuggestionCardHeader_org">;
    readonly " $refType": "SuggestionCard_org";
};
export type SuggestionCard_org$data = SuggestionCard_org;
export type SuggestionCard_org$key = {
    readonly " $data"?: SuggestionCard_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionCard_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionCard_org",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionAction_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBody_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionCardHeader_org"
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = 'cd9f1188713c0de58143eef041d02649';
export default node;
